// extracted by mini-css-extract-plugin
export var standaloneTable = "_hc-0";
export var standaloneTableWithBodyFill = "_hc-1";
export var withExtraHeader = "_hc-2";